var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.197,
    height: 32.815,
    viewBox: "0 0 25.197 32.815",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pdf_2_",
    "data-name": "pdf (2)",
    transform: "translate(-6.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46423",
    "data-name": "Path 46423",
    d: "M24.364,0H7.357C6.884,0,6.5.384,6.5,1.129v31.1a.882.882,0,0,0,.857.586H30.84a.882.882,0,0,0,.857-.586V7.6c0-.408-.054-.539-.151-.636L24.728.151A.518.518,0,0,0,24.364,0Z",
    transform: "translate(0 0)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46424",
    "data-name": "Path 46424",
    d: "M37.5.151V7.094h6.943Z",
    transform: "translate(-12.835 -0.063)",
    fill: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46425",
    "data-name": "Path 46425",
    d: "M18.646,22.387h0a.941.941,0,0,1-.567-.191,1.4,1.4,0,0,1-.653-1.314c.107-.954,1.286-1.952,3.507-2.97a39.335,39.335,0,0,0,2.22-6.3c-.585-1.273-1.153-2.924-.739-3.893a1.124,1.124,0,0,1,.665-.712,2.877,2.877,0,0,1,.6-.1c.3,0,.555.38.739.615s.565.687-.219,3.986a18.724,18.724,0,0,0,2.981,4.431,11.4,11.4,0,0,1,1.968-.21c.918,0,1.474.214,1.7.655a1.186,1.186,0,0,1-.229,1.266,1.557,1.557,0,0,1-1.3.7,3.9,3.9,0,0,1-2.468-1.339,28.077,28.077,0,0,0-5.173,1.654,16.627,16.627,0,0,1-1.4,2.491C19.677,21.995,19.159,22.387,18.646,22.387Zm1.56-3c-1.252.7-1.763,1.282-1.8,1.608-.006.054-.022.2.253.405C18.747,21.369,19.256,21.137,20.206,19.384Zm7.991-2.6c.478.367.594.553.907.553a.883.883,0,0,0,.709-.258.928.928,0,0,0,.135-.243c-.072-.038-.168-.115-.689-.115A8.568,8.568,0,0,0,28.2,16.781ZM23.82,12.924a41.775,41.775,0,0,1-1.567,4.432,29.279,29.279,0,0,1,3.807-1.184A20.058,20.058,0,0,1,23.82,12.924Zm-.356-4.959A1.405,1.405,0,0,0,23.52,9.85C24.077,8.61,23.489,7.957,23.464,7.965Z",
    transform: "translate(-4.52 -2.86)",
    fill: "#f60d0e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46426",
    "data-name": "Path 46426",
    d: "M30.84,48.962H7.357A.857.857,0,0,1,6.5,48.1V39H31.7v9.1A.857.857,0,0,1,30.84,48.962Z",
    transform: "translate(0 -16.147)",
    fill: "#f60d0e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5442",
    "data-name": "Group 5442",
    transform: "translate(11.917 25.153)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46427",
    "data-name": "Path 46427",
    d: "M16.706,48.828h-.962v-5.9h1.7a2.383,2.383,0,0,1,.745.12,2.025,2.025,0,0,1,.661.36,1.882,1.882,0,0,1,.473.581,1.609,1.609,0,0,1,.18.765,2.093,2.093,0,0,1-.152.813,1.7,1.7,0,0,1-.425.613,1.914,1.914,0,0,1-.657.384,2.528,2.528,0,0,1-.849.136h-.713v2.131Zm0-5.175v2.339h.881a1.047,1.047,0,0,0,.349-.06.878.878,0,0,0,.316-.2.96.96,0,0,0,.232-.38,1.8,1.8,0,0,0,.088-.6,1.636,1.636,0,0,0-.04-.332.959.959,0,0,0-.164-.36.971.971,0,0,0-.349-.288,1.3,1.3,0,0,0-.593-.116h-.721Z",
    transform: "translate(-15.744 -42.924)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46428",
    "data-name": "Path 46428",
    d: "M28.851,45.712a4.338,4.338,0,0,1-.156,1.246,3.1,3.1,0,0,1-.4.865,2.038,2.038,0,0,1-.541.549,2.713,2.713,0,0,1-.581.3,2.4,2.4,0,0,1-.513.128,3.413,3.413,0,0,1-.345.027H24.084v-5.9h1.778a3.379,3.379,0,0,1,1.31.236,2.719,2.719,0,0,1,.938.629,2.581,2.581,0,0,1,.557.893A2.957,2.957,0,0,1,28.851,45.712ZM26,48.123a1.592,1.592,0,0,0,1.41-.625,3.171,3.171,0,0,0,.432-1.811,3.067,3.067,0,0,0-.088-.729,1.559,1.559,0,0,0-.34-.653,1.8,1.8,0,0,0-.685-.473,2.95,2.95,0,0,0-1.122-.18h-.561v4.47H26Z",
    transform: "translate(-19.197 -42.924)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46429",
    "data-name": "Path 46429",
    d: "M35.575,43.653v1.859h2.468v.657H35.575v2.66H34.6v-5.9h3.693v.729Z",
    transform: "translate(-23.55 -42.924)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.1dc714647daa56c6003f5fe15aac0a44.svg";
export { ForwardRef as ReactComponent };